export default "__VITE_ASSET__DI$glExo__"